// Events
import { CART_UPDATING, MOUNT_COMPONENTS, THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';
import formatMoney from 'utils/format-money';
import { image } from 'utils/image';
import { useTemplate } from 'utils/node';

export default component((node, ctx) => {
  const { cartItemTemplate, list } = choozy(node);

  const createCartItemElement = useTemplate(cartItemTemplate);

  node.addEventListener('cart:change', (e) => {
    if (e.detail.quantity === 0) {
      e.target.remove();
    }
  });

  ctx.on(THEME_CART_UPDATED, ({ cart, variantsInventory, variantsPrices }) => {
    const cartItems = cart.items.map((item) => {
      const originalLinePrice = variantsPrices[item.variant_id]
        ? variantsPrices[item.variant_id] * item.quantity
        : item.original_line_price;
      let color = [];
      let size = [];
      let amount = [];

      item.options_with_values.forEach(({ name, value }) => {
        const lowerCaseName = name.toLowerCase();
        if (['color', 'colour'].includes(lowerCaseName)) {
          color.push(value);
        } else if (['waist', 'length', 'size'].includes(lowerCaseName)) {
          size.push(value);
        } else if (lowerCaseName === 'amount') {
          amount.push(value);
        }
      });

      color = color.length > 0 ? color.join('/') : null;
      size = size.length > 0 ? size.join('/') : null;
      amount = amount.length > 0 ? amount.join('/') : null;

      return createCartItemElement({
        'data-id': item.key,
        'data-price': item.final_price / 100,
        'data-original-price': originalLinePrice / 100,
        price: formatMoney(item.final_line_price),
        original_price:
          originalLinePrice > item.final_line_price ? formatMoney(originalLinePrice) : '',
        href: item.url,
        'data-min': 1,
        'data-max': variantsInventory[item.variant_id] || 9999,
        value: item.quantity,
        title: item.product_title,
        image: image(item.featured_image, 3 / 4),
        color,
        size,
        amount,
        'data-suit-parent-title': item.product_title,
        'data-suit-parent-color': color,
      });
    });

    list.innerHTML = '';
    list.append(...cartItems);

    node.classList.remove('pointer-events-none');

    ctx.emit(MOUNT_COMPONENTS);
  });

  ctx.on(CART_UPDATING, () => {
    node.classList.add('pointer-events-none');
  });
});
